import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { EVENT_STATUS } from "@/lib/format";
import { Field, Sel, mapOpts } from "@/components/Field";
import { FormDialog, useSubmit, clean } from "./FormDialog";

const EMPTY = { name: "", series: "", description: "", date: "", start_time: "18:00", end_time: "22:00", location: "", manager_id: "", status: "planned", notes: "" };

export const EventDialog = ({ open, onOpenChange, event, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [members, setMembers] = useState([]);
  const [series, setSeries] = useState([]);
  const { saving, run } = useSubmit();
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  useEffect(() => {
    if (!open) return;
    setF(event ? { ...EMPTY, ...Object.fromEntries(Object.keys(EMPTY).map((k) => [k, event[k] ?? ""])), date: event.start.slice(0, 10), end_date: event.end.slice(0, 10), start_time: event.start.slice(11), end_time: event.end.slice(11) } : EMPTY);
    api.get("/members").then((r) => setMembers(r.data.filter((m) => m.status === "active")));
    api.get("/events/series").then((r) => setSeries(r.data)).catch(() => setSeries([]));
  }, [open, event]);

  const submit = () =>
    run(async () => {
      const endDate = f.end_date || f.date;
      const { date, start_time, end_time, end_date, ...rest } = f;
      const body = clean({ ...rest, start: `${date}T${start_time}`, end: `${endDate}T${end_time}` });
      const { data } = event ? await api.patch(`/events/${event.id}`, body) : await api.post("/events", body);
      onOpenChange(false);
      onSaved?.(data);
    }, event ? "Evento aggiornato" : "Evento creato");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title={event ? "Modifica evento" : "Crea evento"} onSubmit={submit} saving={saving} testId="event-dialog">
      <Field label="Nome *"><Input data-testid="event-name-input" required value={f.name} onChange={set("name")} className="h-11" /></Field>
      <Field label="Evento ricorrente" hint="Scegli o scrivi la serie (es. «Sagra») per confrontare gli anni nelle statistiche">
        <Input data-testid="event-series-input" list="event-series-list" value={f.series} onChange={set("series")} className="h-11" placeholder="Nessuna" />
        <datalist id="event-series-list">{series.map((s) => <option key={s} value={s} />)}</datalist>
      </Field>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Data *" className="col-span-3 sm:col-span-1"><Input data-testid="event-date-input" type="date" required value={f.date} onChange={set("date")} className="h-11" /></Field>
        <Field label="Inizio *"><Input data-testid="event-start-input" type="time" required value={f.start_time} onChange={set("start_time")} className="h-11" /></Field>
        <Field label="Fine *"><Input data-testid="event-end-input" type="time" required value={f.end_time} onChange={set("end_time")} className="h-11" /></Field>
      </div>
      <Field label="Data di fine" hint="Solo se l'evento dura più giorni"><Input data-testid="event-enddate-input" type="date" value={f.end_date || ""} onChange={set("end_date")} className="h-11" /></Field>
      <Field label="Luogo"><Input data-testid="event-location-input" value={f.location} onChange={set("location")} className="h-11" /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Responsabile"><Sel testId="event-manager-select" value={f.manager_id} onChange={set("manager_id")} placeholder="—" options={members.map((m) => ({ value: m.user_id, label: m.name }))} /></Field>
        <Field label="Stato"><Sel testId="event-status-select" value={f.status} onChange={set("status")} options={mapOpts(EVENT_STATUS)} /></Field>
      </div>
      <Field label="Descrizione"><Textarea data-testid="event-description-input" value={f.description} onChange={set("description")} rows={2} /></Field>
      <Field label="Note"><Textarea data-testid="event-notes-input" value={f.notes} onChange={set("notes")} rows={2} /></Field>
    </FormDialog>
  );
};
